import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';

import type { EntryCashOut } from './use-entry-cash-out';

export type CashOutSource = 'list' | 'details';

export const withCashOutAnalytics = (cashOut: EntryCashOut, source?: CashOutSource): EntryCashOut => {
    if (!cashOut.controls) {
        return cashOut;
    }
    const { controls } = cashOut;
    return {
        ...cashOut,
        controls: {
            ...controls,
            onCashOut: () => {
                BetrAnalytics.trackProductEvent(AnalyticsEvent.CASH_OUT_START, { source });
                controls.onCashOut();
            },
            onCancel: () => {
                BetrAnalytics.trackProductEvent(AnalyticsEvent.CASH_OUT_CANCEL, { source });
                controls.onCancel();
            },
            onConfirm: () => {
                BetrAnalytics.trackProductEvent(AnalyticsEvent.CASH_OUT_CONFIRM, { source });
                controls.onConfirm();
            },
        },
    };
};
